import React, { useContext, useState } from 'react'
import './appbar.css'
import Logo from '../../assets/new_logo.svg'
import Search from '../../assets/search.svg'
import Notification from '../../assets/Notification.svg'
import Profile from '../../assets/user_default.png'
import { AppContext } from '../../provider'
export const AdminAppbar = () => {
    const { setSidebarIndex, setPageIndex, setExternalService, logout } = useContext(AppContext);
    const loginType = localStorage.getItem('loginType');
    const [query, setQuery] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const commonServices = [
        "Financial", "Banking", "Insurance", "Travel", "Ayushman Bharat",
        "Employment", "Passport", "PAN Card", "Loan", "Seller On Board", "Assisted Shopping"
    ];

    const adminOptions = [
        "Dashboard", "All Service Request",
        "Show All CA/CS List", "Register CA/CS", "Transaction History", "Settings"
    ];

    const cacsOptions = [
        "Dashboard", "Service Requests", "Manage Schedule",
        "Transaction History", "Settings"
    ];

    const data = [...commonServices, ...(loginType === 'Admin' ? adminOptions : cacsOptions)];

    const externalServices = commonServices;

    const filtered = data.filter(item =>
        item.toLowerCase().includes(query.toLowerCase())
    ).sort((a, b) => {
        const q = query.toLowerCase();
        const aStarts = a.toLowerCase().startsWith(q);
        const bStarts = b.toLowerCase().startsWith(q);

        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;

        return a.localeCompare(b);
    });

    function doSearch(key) {
        if (externalServices.includes(key)) {
            console.log("external services : " + key);
            setExternalService(key);
            setPageIndex(1);
            setSidebarIndex(0);
            return;
        }

        if (loginType === 'Admin') {
            switch (key) {
                case "Dashboard": setPageIndex(0); setSidebarIndex(0); setQuery(""); break;
                case "All Service Request": setPageIndex(0); setSidebarIndex(1); setQuery(""); break;

                case "Show All CA/CS List": setPageIndex(0); setSidebarIndex(3); setQuery(""); break;
                case "Register CA/CS": setPageIndex(0); setSidebarIndex(4); setQuery(""); break;
                case "Transaction History": setPageIndex(0); setSidebarIndex(6); setQuery(""); break;
                case "Settings": setPageIndex(0); setSidebarIndex(7); setQuery(""); break;
                default: break;
            }
        } else if (loginType === 'CA/CS') {
            switch (key) {
                case "Dashboard": setPageIndex(0); setSidebarIndex(0); setQuery(""); break;
                case "Service Requests": setPageIndex(0); setSidebarIndex(1); setQuery(""); break;
                case "Manage Schedule": setPageIndex(0); setSidebarIndex(2); setQuery(""); break;
                case "Transaction History": setPageIndex(0); setSidebarIndex(3); setQuery(""); break;
                case "Settings": setPageIndex(0); setSidebarIndex(4); setQuery(""); break;
                default: break;
            }
        }
    }

    return <div className='appbar-div'>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '36px', marginTop: '10px', marginBottom: '15px' }}>
            <img style={{ paddingRight: '10px' }} src={Logo} alt="" />
            <span className='title'>
                GST Web Portal</span>
        </div>

        <div className='searchbar'>
            <img src={Search} alt="" />
            <input
                type="text"
                placeholder="Search services..."
                className="search-input"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                id='search-bar'
                name='search-bar'
            />
            {query && (
                <div className="search-results">
                    {filtered.length > 0 ? (
                        filtered.map((item, index) => (
                            <div onClick={() => {
                                doSearch(item);
                                setQuery('');
                            }} className="search-item" key={index}>
                                {item}
                            </div>
                        ))
                    ) : (
                        <div className="no-results">No results found</div>
                    )}
                </div>
            )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={Notification} alt="" />
            <div className="profile-section" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                <img style={{ marginLeft: '10px', height: '25px', width: '25px' }} src={Profile} alt="" />
                <span style={{ fontFamily: 'Roboto', fontSize: '20', fontWeight: 'bolder', marginLeft: '10px', marginRight: '10px' }}>{loginType}</span>
                <span style={{ fontSize: '10px', transition: 'transform 0.2s', transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0)' }}>▼</span>
                
                {isDropdownOpen && (
                    <div className="profile-dropdown">
                        <div className="dropdown-item" onClick={logout}>
                            <span className="logout-icon">Logout</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>

}